const FLOW_GROUPS = ['a', 'b', 'c', 'd']
const FLOW_LAYERS = ['tail-far', 'tail-mid', 'tail-near', 'head']
const SPECTRUM_STOPS = [
  ['0', '#27e8ff'],
  ['.25', '#765cff'],
  ['.5', '#ff4fc8'],
  ['.75', '#ffe45b'],
  ['1', '#27e8ff']
]

function normaliseDimension(value, fallback) {
  const number = Number(value)
  return Number.isFinite(number) && number >= 2 ? number : fallback
}

export default {
  name: 'PerimeterFlow',
  functional: true,
  props: {
    gradientId: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    radius: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    }
  },
  render(h, context) {
    const width = normaliseDimension(context.props.width, 100)
    const height = normaliseDimension(context.props.height, 100)
    const radius = Math.max(0, Number(context.props.radius) || 0)
    const gradientId = context.props.gradientId
    const inheritedData = context.data || {}
    const rootData = Object.assign({}, inheritedData, {
      staticClass: ['perimeter-flow', inheritedData.staticClass].filter(Boolean).join(' '),
      attrs: Object.assign({}, inheritedData.attrs, {
        viewBox: `0 0 ${width} ${height}`,
        preserveAspectRatio: 'none',
        'aria-hidden': 'true',
        focusable: 'false'
      })
    })
    const rectAttrs = {
      x: '1',
      y: '1',
      width: String(width - 2),
      height: String(height - 2),
      rx: String(radius),
      pathLength: '100'
    }
    const makeRect = (staticClass, stroke) => h('rect', {
      staticClass,
      attrs: Object.assign({}, rectAttrs, { stroke })
    })

    return h('svg', rootData, [
      h('defs', {}, [
        h('linearGradient', {
          attrs: { id: gradientId, x1: '0', y1: '0', x2: '1', y2: '1' }
        }, SPECTRUM_STOPS.map(stop => h('stop', {
          attrs: { offset: stop[0], 'stop-color': stop[1] }
        })))
      ]),
      makeRect('perimeter-flow-track', 'rgba(73, 222, 255, .18)'),
      ...FLOW_GROUPS.map(group => h('g', {
        key: group,
        staticClass: `perimeter-flow-group perimeter-flow-group-${group}`
      }, FLOW_LAYERS.map(layer => makeRect(
        `perimeter-flow-streak perimeter-flow-${layer}`,
        `url(#${gradientId})`
      ))))
    ])
  }
}



// WEBPACK FOOTER //
// ./src/download/perimeter-flow.js